'use strict';

define('vb/private/stateManagement/translationsMixin',[], () => {
  /**
   * Mixin that should be used by all containers to specify the V2 local translations resources.
   */
  const TranslationsMixin = (superclass) => class extends superclass {
    /* eslint-disable max-len */
    /**
     * V2 translations bundle resource name represented by '$default' bundle.
     * For convenience, omit the "-i18n" suffix to the resource name.
     *
     * e.g. app for resources in an appUi; fragments for resources within ui/self/fragments
     *
     * @see https://confluence.oraclecorp.com/confluence/display/ABCS/VBRT+V2+Scoped+Translations+Structure%2C+Configuration+and+Expressions#VBRTV2ScopedTranslationsStructure,ConfigurationandExpressions-DefaultStringResourceNames
     *
     * @type {string}
     */
    // eslint-disable-next-line class-methods-use-this
    get defaultBundleResourceName() {
      throw new Error('Containers must define the defaultBundleResourceName property.');
    }

    /**
     * Location of local V2 translations bundles.
     * For convenience, omit the 'resources/translations/' suffix to the path location.
     *
     * e.g. ui/self/applications/appUi/ for resources in that appUi, or
     * ui/self/fragments/ for resources in any fragment
     *
     * @see https://confluence.oraclecorp.com/confluence/display/ABCS/VBRT+V2+Scoped+Translations+Structure%2C+Configuration+and+Expressions#VBRTV2ScopedTranslationsStructure,ConfigurationandExpressions-StringResourceDirectories
     *
     * @type {string}
     */
    // eslint-disable-next-line class-methods-use-this
    get translationsLocation() {
      throw new Error('Containers must define the translationsLocation property.');
    }
    /* eslint-enable max-len */

    /**
     * Overrides the base impl, so we can customize local translations resource options.
     *
     * @param {Object} [options] Special directives for the bundle definitions
     * @param {boolean} [options.preferV1] If V1 translations config is present, ignore V2 translations config.
     * @param {boolean} [options.proxyBundles] Make proxies for bundles and don't wait for the bundles to be loaded
     * @param {Object} [options.replacementValues] (V1) map of key/value pairs for expressions in path
     * @param {boolean} [options.allowSelfRelative] (V1) let the container JSON use "./" to mean 'relative to the
     * same folder'
     * @param {boolean} [options.isUnrestrictedRelative] (V1) you can reach outside of your current folder
     * (only app-flow)
     * @param {string} [options.location] (V2) Location (directory) of bundles
     * @param {string} [options.defaultBundleResourceName] (V2) Filename of default bundle in location
     *
     * @returns {Promise}
     */
    loadTranslationBundles(options) {
      if (this.loadBundlesPromise) {
        // Do not bother checking everything again
        return this.loadBundlesPromise;
      }

      return super.loadTranslationBundles(Object.assign({
        location: this.translationsLocation,
        defaultBundleResourceName: this.defaultBundleResourceName,
      }, options));
    }
  };

  return TranslationsMixin;
});

